const es = {
  common: {
    wallet: "cartera",
    playPage: "jugar",
    minTop: "cantidad mínima es $10",
    maxTop: "cantidad máxima es $500",
    website: "sitio web",
    signOut: "cerrar sesión",
    hidden: "oculto",
    victory: "victoria",
    wentWrong: "algo salió mal, redirigiendo",
    stakeLabel: "apuesta",
    howDoes: "¿cómo funciona esto?",
    continue: "Continuar",
    continueWithGoogle: "Continuar con Google",
    continueWithApple: "Continuar con Apple",
    termsOfService: "términos de servicio",
    privacyPolicy: "política de privacidad",
    termsOfServiceFooter: "términos de servicio",
    privacyPolicyFooter: "política de privacidad",
    verificationCode: "código de verificación",
    verify: "verificar",
    account: "cuenta",
    error: "ocurrió un error\n",
    checkBackLater: "vuelve más tarde",
    looking: "buscando...",
    yes: "sí",
    no: "no",
    pleaseSelect: "Por favor selecciona\n",
    disclaimer: "al continuar aceptas nuestro\n",
    and: "y",
  },
  endOfGame: {
    wonByCheckmate: "ganó por jaque mate",
    lostOnTime: "perdió por tiempo",
    resigns: "renuncia",
    gameDrawnByAgreement: "juego empatado por acuerdo",
    abandonedTheGame: "abandonó el juego",
    gameAborted: "juego abortado",
    gameDrawnByStalemate: "juego empatado por estancamiento",
    gameDrawnByFiftyMoveRule: "juego empatado por regla de cincuenta movimientos",
    gameDrawnByInsufficientMaterial: "juego empatado por material insuficiente",
    gameDrawnByThreefoldRepetition: "juego empatado por repetición trina",
    draw: "empate",
    victory: "victoria",
    defeat: "derrota",
    aborted: "abortado",
    white: "blanco",
    black: "negro",
    inspectBoard: "ver tablero",
    returnToEndOfGameModal: "continuar",
  },
  byPhone:{
    continueOnPhone: "continuar en\nteléfono",
    or: "o",
    continueOnWeb: "continuar en\nsu navegador",
    disclaimer: "apropiado si tienes una foto de tu ID en el disco"
  },
  signUp: {
    email: "correo electrónico",
    username: "nombre de usuario",
    usernameInvalid: "nombre de usuario inválido",
    emailInvalid: "correo electrónico inválido",
    login: "iniciar sesión",
    continueWithPhone: "continuar con número de teléfono",
    tickBoxes: "vamos a marcar algunas\ncasillas",
    confirm: "Confirmo que\n",
    resideIn: "Resido en\n",
    notPEP: "No soy una persona políticamente expuesta (PEP), un miembro de la familia o un conocido asociado de un PEP\n",
    purpose: "El propósito y la naturaleza de mi relación con Gambit es únicamente para usar el servicio para entretenimiento\n",
    soleBenefit: "Usaré el servicio únicamente para mi beneficio y que no hay otro beneficiario\n",
  },
  identity: {
    beingVerified: "identidad\nestá siendo verificada",
    verified: "verificado\n",
    failed: "verificación\nfallida",
  },
  payment: {
    failed: "pago fallido.\npor favor intente de nuevo",
    successful: "pago\nexitoso!",
    toppedUp: "estás\nrecargado!",
    topUp: "recarga\n",
    payWith: "pagar con...\n",
  },
  gameplay: {
    play: "jugar\n",
    challenge: "te reta a un",
    gameWorth: "juego vale\n",
    whatsYourNumber: "¿cuál es tu\nnúmero?",
    receiveCode: "recibirás un código de verificación\npronto",
    matchedOpponent: "Serás emparejado con un oponente de calificación similar.",
    stake: {
      total: "La apuesta total será la cantidad seleccionada a continuación.",
      contribution: "Contribuirás aproximadamente la mitad de esa cantidad.",
      weakerOpponent: "Si juegas contra un oponente más débil, pagarás una mayor parte de la apuesta.",
      strongerOpponent: "Si juegas contra un oponente más fuerte, pagarás una menor parte de la apuesta.",
    },
    supportInfo: "Visita nuestro soporte para más información.\n",
    continueBrowser: "continuar en\ntu navegador",
    continuePhone: "continuar en\nteléfono",
    getStarted: "vamos a\nempezar",
    sentText: "te hemos enviado\nun mensaje",
    enterReceivedCode: "ingresa el código de verificación\nrecibido",
    wrongCode: "código incorrecto, inténtalo de nuevo\n",
    secPerMove: "seg/mov",
    resign: {
      prompt: "¿estás seguro de que quieres renunciar?",
    },
    draw: {
      offer: "¿aceptar oferta de empate?",
    },
    rating: "calificación\n",
    balance: "saldo\n",
    rematch: "revancha\n",
    newOpponent: "nuevo oponente\n",
    home: "inicio\n",
    rematchOffer: "tu oponente ofrece una revancha. ¿aceptar?",
    leaveGame: "Actualmente estás jugando una partida. ¿Estás seguro de que quieres salir?",
    room: "sala:\n",
    gameTypes: {
      bullet: {
        title: "bala\n",
        description: "Ajedrez de adrenalina. Tú y tu oponente tienen solo 1 minuto cada uno para ganar el juego.",
      },
      blitz: {
        title: "blitz\n",
        description: "Tú y tu oponente tienen 3 minutos cada uno para ganar el juego.",
      },
    },
    stakes: {
      unlockNext: "juega {amount} partidas más para desbloquear la siguiente apuesta",
      allUnlocked: "has desbloqueado todas las apuestas",
    },
    withdraw: "retirar\n",
  },
  puzzle: {
    begin: "comenzar",
    next: "siguiente",
    unavailableInYourRegion: "no disponible",
    puzzle: "rompecabezas",
    whiteToPlay: "blanco a jugar",
    blackToPlay: "negro a jugar",
    time: "tiempo",
    solution: "solución",
    somethingWentWrong: "algo salió mal",
    rating: "calificación",
    credits: "créditos",
    puzzleFailed: "derrota",
    puzzleSolved: "victoria",
    correct: "solución correcta",
    incorrect: "solución incorrecta",
    youRanOutOfTime: "se te acabó el tiempo",
    puzzleDescription: "Tienes 10 segundos + 2 segundos/movimiento para resolver un rompecabezas.",
    creditsLeft: "créditos restantes",
    refillIn: "rellenar en",
    lastPuzzle: "este es tu último rompecabezas, vuelve más tarde para más.",
    outOfCredits: "te has quedado sin créditos, vuelve más tarde.",
    locationPrompt: "Necesitamos tu ubicación para proceder. Si está bloqueada, vuelve a habilitarla:",
    locationInstructions: "Haz clic en el ícono en la barra de direcciones, selecciona 'Permitir siempre' y actualiza la página",
    creditsError: "Error al cargar los créditos",
    moves: "Movimientos:",
  },
};

export {es};